import React, { useEffect, useCallback, useState } from 'react'
import { Form, Select as BaseSelect } from 'antd'
import { Image } from 'components/common'
import { useRules } from 'helpers'

const Select = (props) => {
    const [options, setOptions] = useState([])
    const [data, setData] = useState([])

    const onSearch = useCallback((value) => {
        const filtered = props.list.filter(entry => Object.values(entry).some(val => typeof val === "string" && val.toLowerCase().includes(value.toLowerCase())));
        setData(filtered)
    }, [props.list])

    const onSelect = useCallback(() => {
        setData(props.list)
    }, [props.list])

    const getValueFromEvent = useCallback((args) => {
        if (props.max) {
            return args.slice(0, props.max)
        }
        return args;
    }, [props.max])

    useEffect(() => {
        setData(props.list)
    }, [props.list])

    useEffect(() => {
        const newOptions = []
        const labelKey = props.optionKey ?? 'name'
        const valueKey = props.optionValue ?? 'id'

        data.map(option => {
            newOptions.push({
                label: option[labelKey],
                value: option[valueKey]
            })
        })

        setOptions(newOptions)
    }, [data, props.optionKey, props.optionValue])

    return (
        <Form.Item
            {...props.labelOptions}
            label={props.label}
            name={props.name}
            rules={useRules(props)}
            getValueFromEvent={getValueFromEvent}
            messageVariables={{ errorKey: props.errorKey || props.label }}>
            <BaseSelect
                showSearch={props.showSearch}
                menuItemSelectedIcon={<Image src='/images/mark.svg' />}
                placeholder={props.placeholder}
                onSelect={onSelect}
                onSearch={onSearch}
                mode={props.mode}
                filterOption={false}
                options={options}
                dropdownClassName={props.dropdownClassName}
            />
        </Form.Item>
    )
}

Select.defaultProps = {
    label: '',
    name: '',
    placeholder: '',
    defaultValue: '',
    mode: null,
    required: true,
    rules: [],
    labelOptions: {},
    optionKey: null,
    optionValue: null,
    list: [],
    errorKey: null,
    showSearch: false
}

export default Select
